namespace GeniuzPOS.Inventory {
    export interface IcStkmedthodRow {
        Id?: number;
        Stkmedthod?: string;
        StkmedthodName?: string;
    }

    export namespace IcStkmedthodRow {
        export const idProperty = 'Stkmedthod';
        export const nameProperty = 'StkmedthodName';
        export const localTextPrefix = 'Inventory.IcStkmedthod';
        export const lookupKey = 'Inventory.IcStkmedthod';

        export function getLookup(): Q.Lookup<IcStkmedthodRow> {
            return Q.getLookup<IcStkmedthodRow>('Inventory.IcStkmedthod');
        }
        export const deletePermission = '2Inventory:ระบบ:ตั้งค่าเริ่มต้นระบบสต๊อก:Modify';
        export const insertPermission = '2Inventory:ระบบ:ตั้งค่าเริ่มต้นระบบสต๊อก:Modify';
        export const readPermission = '2Inventory:ระบบ:ตั้งค่าเริ่มต้นระบบสต๊อก:View';
        export const updatePermission = '2Inventory:ระบบ:ตั้งค่าเริ่มต้นระบบสต๊อก:Modify';

        export declare const enum Fields {
            Id = "Id",
            Stkmedthod = "Stkmedthod",
            StkmedthodName = "StkmedthodName"
        }
    }
}
